export const ProductType = {
  Idea: 'Investment_Idea',
  Stock: 'Stocks_Stock',
} as const;

export const OrderType = {
  Idea: 'Investment_BuyOrder',
  Stock: 'Stocks_BuyOrder',
} as const;
